import { ModuleWithProviders, NgModule } from "@angular/core";
import { LOG_LEVEL, LogLevel } from "./logLevel";
import { configureLogger } from "./configureLogger";

/**
 * THis module doesn't supply any components or services, but it does provide a way to configure the default log level
 * in an Angular way.
 */
@NgModule({
    providers: [
        {
            provide: LOG_LEVEL,
            useValue: LogLevel.INFORMATION,
            multi: false,
        },
    ]
})
export class LoggerModule
{
    static forRoot(options: {
        logLevel: LogLevel;
    }): ModuleWithProviders<LoggerModule>
    {
        configureLogger(options.logLevel);

        return {
            ngModule: LoggerModule,
            providers: [
                {
                    provide: LOG_LEVEL,
                    useValue: options.logLevel,
                    multi: false,
                },
            ],
        };
    }
}
